
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBuyerPaymentShipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sellerShipmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shortAmount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sellerComissionDeducted"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentModeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceNo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chequeNo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chequeBank"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chequeDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"discountApplicablePercent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullPayment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBuyerPaymentShipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sellerShipmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sellerShipmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"shortAmount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shortAmount"}}},{"kind":"Argument","name":{"kind":"Name","value":"sellerComissionDeducted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sellerComissionDeducted"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMode"}}},{"kind":"Argument","name":{"kind":"Name","value":"referenceNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceNo"}}},{"kind":"Argument","name":{"kind":"Name","value":"chequeNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chequeNo"}}},{"kind":"Argument","name":{"kind":"Name","value":"chequeBank"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chequeBank"}}},{"kind":"Argument","name":{"kind":"Name","value":"chequeDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chequeDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"discountApplicablePercent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"discountApplicablePercent"}}},{"kind":"Argument","name":{"kind":"Name","value":"fullPayment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullPayment"}}}],"directives":[]}]}}],"loc":{"start":0,"end":788}};
    doc.loc.source = {"body":"mutation createBuyerPaymentShipment (\n  $sellerShipmentId: Int!\n  $amount: Float!\n  $shortAmount: Float!\n  $sellerComissionDeducted: Float!\n  $paymentDate: String\n  $paymentMode: PaymentModeEnum!\n  $referenceNo: String\n  $chequeNo: String\n  $chequeBank: String\n  $chequeDate: String\n  $discountApplicablePercent: Float!\n  $fullPayment: Boolean!\n) {\n  createBuyerPaymentShipment (\n    sellerShipmentId: $sellerShipmentId\n    amount: $amount\n    shortAmount: $shortAmount\n    sellerComissionDeducted: $sellerComissionDeducted\n    paymentDate: $paymentDate\n    paymentMode: $paymentMode\n    referenceNo: $referenceNo\n    chequeNo: $chequeNo\n    chequeBank: $chequeBank\n    chequeDate: $chequeDate\n    discountApplicablePercent: $discountApplicablePercent\n    fullPayment: $fullPayment\n  )\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createBuyerPaymentShipment"] = oneQuery(doc, "createBuyerPaymentShipment");
        
